import { jsonToFormData } from 'util/jsonToFormData';

import { datadogRum } from '@datadog/browser-rum';
import { RumAction } from 'config/datadog/rumEvents';
import { selectAdminWriteApiUrl } from 'selector/apiSelector';

export const backendApiBeaconClient = (path: string, data: unknown): boolean => {
  const queued = navigator.sendBeacon(`${selectAdminWriteApiUrl()}${path}`, jsonToFormData(data));

  // sendBeacon's boolean only means the browser queued the request, not that it
  // was delivered; the RUM SDK flushes on page exit, so this action is best-effort.
  datadogRum.addAction(RumAction.SAVE_BEACON_SENT, { ok: queued });

  return queued;
};
